const DRAWER_HARDWARE_REFERENCES = new Set([
  'STUD',
  'PLUG',
  'TURN',
  'RENFO',
  'PARA',
  'NUTM4',
  '29240.035.030',
  'VISM4X8MM',
  'VISM4X23MM',
  'VIS4X30MM',
  'FVM',
]);

const DRAWER_HARDWARE_PREFIXES = ['DRP-', 'DRK-'];

const FURNITURE_SMALL_PART_REFERENCES = new Set([
  'CB',
  'CBL',
  'CBR',
  'CC',
  'CG',
  'CGA',
  'CGS',
  'CJ',
  'CN',
  'CR',
  'CV',
]);

const DRAWER_SCREW_REFERENCES = new Set([
  '29240.035.030',
  'VISM4X8MM',
  'VISM4X23MM',
  'VIS4X30MM',
  'FVM',
]);

const DRAWER_HARDWARE_REFERENCE_ORDER = new Map<string, number>([
  ['29240.035.030', 0],
  ['RENFO', 1],
  ['NUTM4', 4],
  ['VIS4X30MM', 5],
  ['PLUG', 6],
  ['STUD', 7],
  ['TURN', 8],
]);

const DRAWER_SUPPORT_REFERENCES = new Set([
  'SD10-W',
  'SD10-X',
  'SD10-Y',
  'SD10-Z',
  'SD13-W',
  'SD13-X',
  'SD13-Y',
  'SD13-Z',
  'SD17-W',
  'SD17-X',
  'SD17-Y',
  'SD17-Z',
  'SD20-W',
  'SD20-X',
  'SD20-Y',
  'SD20-Z',
  'SD27-W',
  'SD27-X',
  'SD27-Y',
  'SD27-Z',
  'SD37-W',
  'SD37-X',
  'SD37-Y',
  'SD37-Z',
]);

const DRAWER_SLAT_REFERENCES = new Set(['SULI-W', 'SULI-X', 'SULI-Y', 'SULI-Z']);

const normalizeReference = (reference: string): string =>
  reference.replace(/ *\[[^\]]*]/, '').trim();

export const isDrawerHardwareReference = (reference: string): boolean => {
  const normalizedReference = normalizeReference(reference);

  return (
    DRAWER_HARDWARE_REFERENCES.has(normalizedReference) ||
    DRAWER_HARDWARE_PREFIXES.some(prefix =>
      normalizedReference.startsWith(prefix),
    )
  );
};

export const getDrawerHardwareGroup = (
  reference: string,
): number | undefined => {
  const normalizedReference = normalizeReference(reference);

  if (!isDrawerHardwareReference(normalizedReference)) return undefined;
  if (DRAWER_HARDWARE_REFERENCE_ORDER.has(normalizedReference)) {
    return DRAWER_HARDWARE_REFERENCE_ORDER.get(normalizedReference);
  }
  if (normalizedReference.startsWith('DRP-')) return 2;
  if (normalizedReference.startsWith('DRK-')) return 3;
  if (DRAWER_SCREW_REFERENCES.has(normalizedReference)) return 100;

  return 90;
};

export const isFurnitureSmallPartReference = (reference: string): boolean => {
  const normalizedReference = normalizeReference(reference);

  return (
    FURNITURE_SMALL_PART_REFERENCES.has(normalizedReference) ||
    normalizedReference.startsWith('DRK-')
  );
};

export const getDrawerStandardGroup = (
  reference: string,
): number | undefined => {
  const normalizedReference = normalizeReference(reference);

  if (normalizedReference.startsWith('DD')) return 0;
  if (normalizedReference.startsWith('NDL-')) return 1;
  if (/^NDL\d/.test(normalizedReference)) return 2;
  if (DRAWER_SUPPORT_REFERENCES.has(normalizedReference)) return 4;
  if (DRAWER_SLAT_REFERENCES.has(normalizedReference)) return 5;

  return 3;
};
